import React from "react";
import SmartShoeImage from "../../../../../assets/learnersCourses/iotCourses/introductiontoInternetofThings.webp";
import Amazon from "../../../../../assets/learnersCourses/iotCourses/ioTandEmbeddedSystemswithESP32.webp";
import Microsoft  from "../../../../../assets/learnersCourses/iotCourses/fullStackIoTJSMERNRaspberryPi.webp";
import Internet from "../../../../../assets/learnersCourses/iotCourses/masterESP32BluetoothandBLEHandsOnProjectsforIoTCommunication.webp";
import SmartHome from "../../../../../assets/learnersCourses/iotCourses/masterWIFIcommunication.webp";
import ESP32Arduino from "../../../../../assets/learnersCourses/iotCourses/longdistancewirelessnetworksCellularLoRaNBIOT.webp";
import NodeMCUMATLAB from "../../../../../assets/learnersCourses/iotCourses/masteringMQTT.webp";
import NternetESP32Arduino from "../../../../../assets/learnersCourses/iotCourses/ioTandEmbeddedSystemswithESP32.webp";
import NodeRed from "../../../../../assets/learnersCourses/iotCourses/masterNode-RedfromBasictoAdvanced.webp";
import BluetoothTechnology from "../../../../../assets/learnersCourses/iotCourses/edgeComputing.webp";
import JavaScript from "../../../../../assets/learnersCourses/iotCourses/pythonProgramming.webp";
import SystemsProject from "../../../../../assets/learnersCourses/iotCourses/ioTusingRaspberryPiandPython.webp";
import SmartusingESP32 from "../../../../../assets/learnersCourses/iotCourses/aWSIoTCertificationTraining.webp";

const courses = [
  {
    courseId: 1,
    courseTitle: "Introduction to Internet of Things",
    videoUrl: "",
    image: SmartShoeImage,
    Skills: "",
    completion: 0
  },
  {
    courseId: 2,
    courseTitle: "IoT and Embedded Systems with ESP32",
    videoUrl: "",
    image: Amazon,
    Skills: "",
    completion: 0
  },
  {
    courseId: 3,
    courseTitle: "IoT using Raspberry Pi and Python",
    videoUrl: "",
    image: Microsoft,
    Skills: "",
    completion: 0
  },
  {
    courseId: 4,
    courseTitle: "Master ESP32, Bluetooth, and BLE: Hands-On Projects for IoT Communication ",
    videoUrl: "",
    image: Internet,
    Skills: "",
    completion: 0
  },
  {
    courseId: 5,
    courseTitle: "Master WIFI communication",
    videoUrl: "",
    image: SmartHome,
    Skills: "",
    completion: 0
  },
  {
    courseId: 6,
    courseTitle: "Long distance wireless networks: GSM, Lora, NBIOT",
    videoUrl: "",
    image:  ESP32Arduino,
    completion: 0
  },
  {
    courseId: 7,
    courseTitle: "Master MQTT",
    videoUrl: "", 
    image: NodeMCUMATLAB,
    completion: 0
  },
  {
    courseId: 8,
    courseTitle: "Embedded Systems using ESP32 and ESP-IDF",
    videoUrl: "",
    image: NternetESP32Arduino,
    completion: 0
  },
  {
    courseId: 9,
    courseTitle: "Ethical Hacking and Cyber Security Fundamentals",
    videoUrl: "", 
    image: NodeRed,
    completion: 0
  },
  {
    courseId: 10,
    courseTitle: "IoT Security Mega Course",
    videoUrl: "", 
    image: BluetoothTechnology,
    completion: 0
  },
  {
    courseId: 11,
    courseTitle: "IoT Testing ",
    videoUrl: "", 
    image: JavaScript,
    completion: 0
  },
  {
    courseId: 12,
    courseTitle: "Cybersecurity with Raspberry Pi and Kali Linux",
    videoUrl: "", 
    image: SystemsProject,
    completion: 0
  },
  {
    courseId: 13,
    courseTitle: "Advanced IoT Security and Tools",
    videoUrl: "", 
    image: SmartusingESP32,
    completion: 0
  }
];

const Start = () => {


  return (
    <div>
    <div className="mylearningpaths">
      <h1 className="mylearningpaths-h1">IoT Security Specialist</h1>
      <p className="mylearningpaths-p">Courses</p>
      <div className="mylearningpath">
        <div className="Wrapper-sc-fvyqwl-1 iZEyIQ AssignmentList__Timeline-sc-1t9paan-2 chIzFH">
          <ul className="Circle-sc-fvyqwl-1">
            {courses.map((course, index) => (
              <li key={course.courseId}>
                <div className="learningpath-courses-dashboard">
                  <div>
                  <img src={course.image} alt={course.courseTitle} className="smart-shoe-development" />
                  </div>
                  <div>
                  <p className={`pythoncourses${course.courseId}`} style={{paddingTop : "10px",}}>
                  {index + 1}. {course.courseTitle}
                  </p>
                  <p className="learningpath-courses-dashboard-skills">Skills: <span className="learningpath-courses-dashboard-skills-span">{course.Skills}</span></p>
                  <div className="learningpath-courses-dashboard-progressbar">
                  <p className="learningpath-courses-dashboard-skills-completed">{course.completion}%</p>
                  </div>
                  <div>
                     <div>
                    {course.completion === 100 ? (
                      <button className="learningpath-courses-dashboard-button-start">Download Certificate</button>
                    ) : course.completion >= 10 ? (
                      <button  className="learningpath-courses-dashboard-button-start">Continue Learning</button>
                    ) : (
                      <button className="learningpath-courses-dashboard-button-start">Start Learning</button>
                    )}
                  </div>
                  </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <p className="mylearningpaths-p">Recommended Projects</p>
    </div>
  </div>
);
};

export default Start;